import axios from "axios";

export const DisclaimerAPI={
    get:function() {
       return axios({
            method:'GET',
            url: `${process.env.REACT_APP_API_URL}/get-disclaimer`,
        })
    }
}
